module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/PK-26321fb1e84b1c6e9433012ec090978e.png";